import { Link } from 'react-router-dom';
import { Row, Col, Card, CardBody, CardTitle, CardText, Badge } from 'reactstrap';

/**
 * Wiederverwendbares Karten-Grid für Settings-/Übersichts-Landingpages
 * (analog CoreSettingsOverview). Jede Karte verlinkt auf eine Sub-Route
 * ODER — wenn `href` gesetzt ist — auf eine externe URL (neuer Tab).
 *
 * status: 'live' (grün), 'planned' (grau), 'external' (blau).
 */
const STATUS = {
  live:     { color: 'success',   label: 'live' },
  planned:  { color: 'secondary', label: 'geplant' },
  external: { color: 'info',      label: 'extern' },
  beta:     { color: 'warning',   label: 'beta' },
};

export function OverviewGrid({ cards }) {
  return (
    <Row className="g-3">
      {cards.map((c) => {
        const s = STATUS[c.status] ?? STATUS.live;
        const clickable = c.to || c.href;
        const linkProps = c.href
          ? { tag: 'a', href: c.href, target: '_blank', rel: 'noreferrer' }
          : c.to
          ? { tag: Link, to: c.to }
          : {};
        return (
          <Col md="6" lg="4" key={c.title}>
            <Card
              {...linkProps}
              className="h-100 text-decoration-none text-body"
              style={{ cursor: clickable ? 'pointer' : 'default', opacity: c.status === 'planned' ? 0.85 : 1 }}
            >
              <CardBody>
                <CardTitle tag="h6" className="d-flex align-items-center justify-content-between mb-2">
                  <span>
                    <span className="me-2" aria-hidden>{c.icon}</span>
                    {c.title}
                  </span>
                  <Badge color={s.color} pill className="small">{s.label}</Badge>
                </CardTitle>
                <CardText className="text-muted small mb-2">{c.description}</CardText>
                {clickable && (
                  <span className="text-primary small">
                    {c.href ? 'Extern öffnen ↗' : 'Öffnen →'}
                  </span>
                )}
              </CardBody>
            </Card>
          </Col>
        );
      })}
    </Row>
  );
}
